import React, { useEffect, useContext } from 'react';
import ReactGA from 'react-ga';
import AboutCompanyLayout from './about-company-layout';
import {
    Borrower,
    useSetCompanyInformationMutation,
    useGetLoanQuery,
} from 'generated/graphql';
import { useNavigation } from 'hooks/index';
import useNeuroId from 'hooks/neuro-id';
import { ProfileContext } from 'providers/profile.provider';
import { registerTagmanagerEvent, TagManagerEvent } from 'configs/trackers';
import { LoanApplicationContext } from 'containers/context/useGetLoanApplication';

const AboutCompany: React.FC = () => {
    const [setCompanyInformation] = useSetCompanyInformationMutation();
    const { nextScreen, previousScreen, reset } = useNavigation();
    const { loanApplicationId } = useContext(LoanApplicationContext);
    const {
        steps: { aboutCompany },
        profile,
    } = useContext(ProfileContext);

    const { setUserId } = useNeuroId();

    const { data } = useGetLoanQuery({
        variables: {
            id: loanApplicationId,
        },
        fetchPolicy: 'cache-first',
    });

    useEffect(() => {
        if (!loanApplicationId) {
            reset();
        }
        setUserId(loanApplicationId);
    }, [loanApplicationId]);

    useEffect(() => {
        ReactGA.event({
            category: 'Navegação Direto',
            action: 'Exibição',
            label: 'Exibição /pedido/sobre-a-empresa',
            nonInteraction: true,
        });
    }, []);

    const onSubmit = (borrower: Borrower) => {
        const { companyDocument, monthlyRevenue, relationship } = borrower;

        setCompanyInformation({
            variables: {
                loanApplicationId: data?.loanApplication.id,
                borrower: { companyDocument, monthlyRevenue, relationship },
            },
            onCompleted: () => {
                nextScreen();
                registerTagmanagerEvent(TagManagerEvent.COMPLETE_PROFILE, {
                    relation: relationship,
                });
            },
        });
    };

    return (
        <AboutCompanyLayout
            initialValue={data?.loanApplication.borrower}
            stepInfo={aboutCompany}
            onBack={previousScreen}
            onSubmit={onSubmit}
            screenProfile={profile}
        />
    );
};

export default AboutCompany;
